export default {"src":"/_next/static/media/sale-bg.f178aafe.svg","height":65,"width":75,"blurWidth":0,"blurHeight":0};